import { ReactNode } from 'react';
// Import Enums
import { WhatsAppComponentPropertyKeyEnum, WhatsAppComponentTypeEnum } from 'enums';
import type { WhatsAppTemplateButton } from 'types';
// Import Types
import { ComponentParts, WhatsAppTemplateComponent } from './types';

export const getComponentProperty = (
    component: Nilable<WhatsAppTemplateComponent>,
    propertyKey: WhatsAppComponentPropertyKeyEnum,
): unknown => {
    const pascalCaseKey = propertyKey.charAt(0).toUpperCase() + propertyKey.slice(1);

    return component?.[pascalCaseKey] ?? '';
};

export const getComponentParts = (components: Nilable<WhatsAppTemplateComponent[]>): ComponentParts => {
    const emptyParts: ComponentParts = {
        header: null,
        body: null,
        footer: null,
        buttons: null,
    };

    if (!Array.isArray(components) || components.length === 0) {
        return emptyParts;
    }

    const parts = { ...emptyParts };

    components.forEach((component: WhatsAppTemplateComponent) => {
        const componentType =
            (getComponentProperty(component, WhatsAppComponentPropertyKeyEnum.Type) as string)?.toUpperCase() ?? '';
        if (componentType === WhatsAppComponentTypeEnum.Header) parts.header = component;
        else if (componentType === WhatsAppComponentTypeEnum.Body) parts.body = component;
        else if (componentType === WhatsAppComponentTypeEnum.Footer) parts.footer = component;
        else if (componentType === WhatsAppComponentTypeEnum.Buttons) parts.buttons = component;
    });

    return parts;
};

export const getButtonLabel = (button: Partial<WhatsAppTemplateButton>): string => {
    return button?.Text ?? '';
};

export const renderTextSection = (className: string, text: Nilable<string>): ReactNode => {
    if (!text) return null;

    return <div className={className}>{text}</div>;
};
